module.exports = __webpack_public_path__ + "media/promo/velle/images/top_products/prod_3__mob-4331d6c0bc8cfa08ba40efab2a152b59.png";